var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}]},[_c('p',{staticClass:"text-sm text-red-600",domProps:{"innerHTML":_vm._s(_vm.message)}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }